import LMU from './LMU.png';
import animojiMac from './animojiMac.png';
import carsync from './carsync.png';
import gyrosnake from './gyrosnake.png';
import javaLogo from './javaLogo.png';
import pythonLogo from './pythonLogo.png';
import reactLogo from './reactLogo.png';
import swiftLogo from './swiftLogo.png';
import wallpaper from './wallpaper.png';
import trackbill from './trackbill.png';
import wittelsbacherGymnasium from './wittelsbacherGymnasium.png';

const images = {
  'LMU.png': LMU,
  'animojiMac.png': animojiMac,
  'carsync.png': carsync,
  'gyrosnake.png': gyrosnake,
  'javaLogo.png': javaLogo,
  'pythonLogo.png': pythonLogo,
  'reactLogo.png': reactLogo,
  'swiftLogo.png': swiftLogo,
  'wallpaper.png': wallpaper,
  'trackbill.png': trackbill,
  'wittelsbacherGymnasium.png': wittelsbacherGymnasium
};

export default images;
